import { useState, useMemo } from "react";
import { useGetWorldCitiesQuery } from "../features/auth/authApiSlice";

export function useLocationData() {
  const { data: worldCities = [] } = useGetWorldCitiesQuery();

  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  /* Derived country list — only recomputed when worldCities changes */
  const countryList = useMemo(() => {
    const unique = [
      ...new Set(worldCities.map((item) => item.country).filter(Boolean)),
    ];
    return unique.sort();
  }, [worldCities]);

  const handleCountryChange = (e) => {
    const states = [
      ...new Set(
        worldCities
          .filter((item) => item.country === e.target.value)
          .map((item) => item.subcountry)
          .filter(Boolean),
      ),
    ].sort();
    setStateList(states);
    setCityList([]); // Clear city list when country changes
  };

  const handleStateSelect = (stateName) => {
    const cities = worldCities.filter(
      (item) =>
        item.subcountry === stateName &&
        typeof item.name === "string" &&
        item.name.length > 0,
    );
    setCityList(cities);
  };

  // Provide legacy/alias names expected by UI components
  const handleCountryChangestate = (e) => handleStateSelect(e?.target?.value);
  const handleCountryChangecity = (e) => {
    /* placeholder: UI handles selected city value separately */
    return;
  };

  return {
    // canonical names
    countryList,
    stateList,
    cityList,
    handleCountryChange,
    handleStateSelect,
    // aliases for existing UI code
    country: countryList,
    getState: stateList,
    getcity: cityList,
    handleCountryChangestate,
    handleCountryChangecity,
  };
}
